export default "__VITE_ASSET__BVZLiVZq__"